'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/dom-scroll-into-view/lib/index.js
// module id = 522
// module chunks = 20